import React from "react";
import { BrowserRouter as Router, Route, Switch } from "react-router-dom";

// assets import
import "./assets/scss/app.scss";
import "font-awesome/css/font-awesome.min.css";
import "./assets/fonts/OPTIMA.TTF";
import "./assets/fonts/OPTIMA_B.TTF";
import AOS from "aos";
import "aos/dist/aos.css";

import { NavLink } from "react-router-dom";
import Header from "./components/header";
import Footer from "./components/footer";
import Modal from "./components/modal";
import Home from "./pages/home";
import FootClinic from "./pages/foot-clinic";
import Booking from "./pages/booking";
import ScrollToTop from "./components/scroll-to-top";

// Service detail pages
import GeneralPodiatryDetail from "./pages/services/general-podiatry";
import ParaffinWaxBathDetail from "./pages/services/paraffin-wax-bath";
import FungalTestingDetail from "./pages/services/fungal-testing";
import PressurePlateAnalysisDetail from "./pages/services/pressure-plate-analysis";
import VideoGaitAnalysisDetail from "./pages/services/video-gait-analysis";
import BiomechanicalAssessmentDetail from "./pages/services/biomechanical-assessment";
import UltrasoundTherapyDetail from "./pages/services/ultrasound-therapy";
import OrthoticsDetail from "./pages/services/orthotics";
import DiabeticFootCareDetail from "./pages/services/diabetic-foot-care";
import PlantarFasciitisDetail from "./pages/services/plantar-fasciitis";

const NoMatch = () => (
  <div className="not-found gel-wrap gs-u-align-center">
    <h1 className="spacing-slice">404</h1>
    <h3 className="gs-u-mb+">Ooops!</h3>
    <p className="gs-u-mb">
      {"That page doesn't exist or is currently unavailable."}
    </p>
    <NavLink className="button gs-u-pv+ gs-u-ph++ spacing-slice--bottom" to="/">
      Take me back to the home page
    </NavLink>
  </div>
);

class App extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      isModalOpen: false,
    };

    this.setIsModalOpen = this.setIsModalOpen.bind(this);
  }

  componentDidMount() {
    AOS.init({ once: true });
  }

  setIsModalOpen(isModalOpen) {
    this.setState({
      isModalOpen,
    });
  }

  render() {
    return (
      <Router onUpdate={() => window.scrollTo(0, 0)}>
        <ScrollToTop />
        <>
          <Header setIsModalOpen={this.setIsModalOpen} />
          <main className="gs-u-box-size">
            <Switch>
              <Route
                exact
                path="/"
                component={() => (
                  <Home
                    isModalOpen={this.state.isModalOpen}
                    setIsModalOpen={this.setIsModalOpen}
                  />
                )}
              />
              <Route exact path="/foot-clinic" component={FootClinic} />
              <Route exact path="/foot-clinic/booking" component={Booking} />

              {/* Service detail pages */}
              <Route
                exact
                path="/foot-clinic/services/general-podiatry"
                component={GeneralPodiatryDetail}
              />
              <Route
                exact
                path="/foot-clinic/services/paraffin-wax-bath"
                component={ParaffinWaxBathDetail}
              />
              <Route
                exact
                path="/foot-clinic/services/fungal-testing"
                component={FungalTestingDetail}
              />
              <Route
                exact
                path="/foot-clinic/services/pressure-plate-analysis"
                component={PressurePlateAnalysisDetail}
              />
              <Route
                exact
                path="/foot-clinic/services/video-gait-analysis"
                component={VideoGaitAnalysisDetail}
              />
              <Route
                exact
                path="/foot-clinic/services/biomechanical-assessment"
                component={BiomechanicalAssessmentDetail}
              />
              <Route
                exact
                path="/foot-clinic/services/ultrasound-therapy"
                component={UltrasoundTherapyDetail}
              />
              <Route
                exact
                path="/foot-clinic/services/orthotics"
                component={OrthoticsDetail}
              />
              <Route
                exact
                path="/foot-clinic/services/diabetic-foot-care"
                component={DiabeticFootCareDetail}
              />
              <Route
                exact
                path="/foot-clinic/services/plantar-fasciitis"
                component={PlantarFasciitisDetail}
              />

              <Route exact path="*" component={NoMatch} />
            </Switch>
          </main>
          <Footer />
          <Modal
            isModalOpen={this.state.isModalOpen}
            setIsModalOpen={this.setIsModalOpen}
          />
        </>
      </Router>
    );
  }
}

export default App;
